import { apiFetcher} from '@/api/api'
import { useCacheSWR } from '@/api/swrCache'
import useSWRMutation from 'swr/mutation'



// 获取兑换汇率
export function useQueryExchangeRate() {
  const fetcher = () => {
    return apiFetcher (
      {
        path: '/fd/api/v1/transfer/getTransferRate',
        type: 'post'
      },
      {
        arg: {}
      }
    )
  }

  const result = useCacheSWR('useQueryExchangeRate', fetcher, {
    dedupingInterval: 10 * 1000
  })

  return result
}

// 兑换
export function useExchangeTransfer() {
  const params = {
    path: '/fd/api/v1/transfer/utcTransfer',
    type: 'post',
    needToken: true
  }
  return useSWRMutation(params, (params, arg: { arg: any }) => {
    return apiFetcher<any>(params, { ...arg })
  })
}
